export class TimedSessionStorage {
    private static calculateExpirationMs(expirationMinutes: number): number {
        return expirationMinutes * 60 * 1000; // Convert minutes to milliseconds
    }

    private static getCurrentTime(): number {
        return new Date().getTime();
    }

    static setItemWithExpiration(key: string, value: any, expirationMinutes: number = 5): void {
        const expirationTime = this.calculateExpirationMs(expirationMinutes);
        const data = {
            value: JSON.stringify(value),
            expiration: this.getCurrentTime() + expirationTime,
        };
        sessionStorage.setItem(key, JSON.stringify(data));
    }

    static getItemWithExpiration(key: string): any {
        try {
            const data = sessionStorage.getItem(key);
            if (!data) {
                return null;
            }
            const parsedData = JSON.parse(data);
            const currentTime = this.getCurrentTime();
            if (currentTime > parsedData?.expiration) {
                sessionStorage.removeItem(key);
                return null;
            }
            return JSON.parse(parsedData?.value);
        } catch (error) {
            return null;
        }
    }
}
